import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { StaticContent } from '@models/static-content.model';
import { ConfigService } from '@services/config.service';
import { ContentService } from '@services/content.service';
import { NavbarLink } from 'src/environments/environment.base';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})
export class FooterComponent implements OnInit {
  logoContent: StaticContent | undefined = this.contentService.getContentByShortCode('logo');
  links: StaticContent[] = [];

  constructor(
    private contentService: ContentService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.links = this.contentService.getContentsByType('footer_link');
  }


  openLink(link: StaticContent) {
    if (link.content.substring(0,4) === 'http') {
      window.location.href = link.content;
      return;
    }

    this.router.navigateByUrl(link.content);
  }
}
